import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TransactionHistory from "../../components/TransactionHistory/TransactionHistory";
import LoginHeader from "../../components/header/Loginheader";
import Footer from "../../components/footer/FooterW";
import bankicon from "../../images/shapes/bank-pound-icon2 4.png";
import wallet from "../../images/shapes/Group 37274 (1).png";
import "../Wallet/Wallet.css";
import { useLocation } from "react-router-dom";
import RewardPopup from "../../components/Rewardpopup/RewardPopup";
import { API_URL } from "../../constant";

const UserProfileWallet = () => {
  const [transactions, setTransactions] = useState([]);
  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);
  const [showMessage, setShowMessage] = useState(false);

  const handleClick = () => {
    if (balance < 20000) {
      setShowMessage(true);

      // Hide after 5 seconds
      setTimeout(() => {
        setShowMessage(false);
      }, 5000);
    } else {
      alert("Conversion process started!");
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const firstLogin = queryParams.get("firstLogin") === "true";
    
    const initWallet = async () => {
      try {
        // Step 1: Get token from localStorage
        const token = localStorage.getItem("auth_token");

        if (!token) {
          navigate("/login");
          return;
        }

        // Set first login popup if needed
        if (firstLogin) {
          setShowPopup(true);
          // Clear the URL parameter
          window.history.replaceState({}, document.title, "/customer/wallet");
        }

        // Step 2: Fetch user data to verify token is valid
        const userResponse = await fetch(`${API_URL}/api/me`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!userResponse.ok) {
          // Token is invalid, redirect to login
          localStorage.removeItem("auth_token");
          navigate("/login");
          return;
        }

        const userData = await userResponse.json();
        setUser(userData.user);

        // Step 3: Fetch wallet data
        const walletResponse = await fetch(`${API_URL}/api/wallet`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const contentType = walletResponse.headers.get("content-type");
        const isJson = contentType && contentType.includes("application/json");

        if (!walletResponse.ok) {
          const errorData = isJson
            ? await walletResponse.json()
            : await walletResponse.text();
          const message = isJson
            ? errorData.message || "Failed to fetch wallet data"
            : `Error ${walletResponse.status}: ${walletResponse.statusText}`;
          throw new Error(message);
        }

        const walletData = await walletResponse.json();
        setTransactions(walletData.transactions || []);
        setBalance(walletData.points || 0);
      } catch (error) {
        console.error("🚨 Wallet fetch error:", error.message);
        // If there's an error, redirect to login
        localStorage.removeItem("auth_token");
        navigate("/login");
      } finally {
        setLoading(false);
      }
    };

    initWallet();
  }, [navigate, location]);

  const handleLogout = () => {
    // Call logout API
    fetch(`${API_URL}/api/logout`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
      },
    })
    .then(() => {
      // Clear local storage and redirect
      localStorage.removeItem("auth_token");
      localStorage.removeItem("tempPassword");
      navigate("/login");
    })
    .catch(error => {
      console.error("Logout error:", error);
      // Still clear local storage and redirect even if API call fails
      localStorage.removeItem("auth_token");
      localStorage.removeItem("tempPassword");
      navigate("/login");
    });
  };

  // Show loading UI while fetching
  if (loading) {
    return (
      <div className="wallet-loading">
        <LoginHeader user={user} onLogout={handleLogout} />
        <div className="wallet-container">
          <div className="wallet-content">
            <div className="wallet-left">
              <div className="wallet-left-text">
                <h2 className="highlight">TopCoin UK Wallet</h2>
                <p className="balance-label">Available Balance</p>
                <h1 className="balance-value">Loading...</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="py-5">
      {showPopup && <RewardPopup onClose={() => setShowPopup(false)} />}
      <LoginHeader user={user} onLogout={handleLogout} />
      <div className="wallet-container">
        <div className="wallet-content">
          <div className="wallet-left">
            <div className="wallet-left-text">
              <h2 className="highlight">TopCoin UK Wallet</h2>
              <img className="wallet-icon1" src="./tc-units-wallet 2.png" alt="wallet icon" />
              <p className="balance-label">Available Balance</p>
              <h1 className="balance-value">{balance} TopCoin</h1>
              <div className="mb-8 pt-4 text-center">
                <a
                  href="/transaction"
                  style={{
                    color: "#9F4AFF",
                    fontWeight: "500",
                    textDecoration: "none",
                  }}
                >
                  Transaction History &gt;&gt;
                </a>
              </div>
            </div>

            <div className="wallet-left-text wallet-left-text2">
              <h2 className="highlight">TopCoin UK Current Total Value</h2>

              <img className="wallet-icon1" src="./wallet-cash-icon3 2.png" alt="wallet icon" />
               <h1 className="coin-value">
                Current value = £{(balance * 0.005).toFixed(2)}
              </h1>

            </div>
          </div>

          <div className="wallet-left wallet-left1">
            <div className="wallet-left-text wallet-left-text1">
              <h2 className="highlight">TopCoin UK Cash Wallet</h2>

              <img className="wallet-icon1" src="./tc-cash-wallet 1.png" alt="wallet icon" />
               <h2 className="highlight cash-wallet1">N/A</h2>

            </div>

            <div className="bank-request">
              <p className="convert-text">Convert your TopCoin into cash</p>
              <img className="bank-icon" src={bankicon} alt="bankicon" />
              <h1 className="coin-value " style={{ color: "#888" }}>
                Request to bank
              </h1>
              <button
                className={
                  balance >= 20000 ? "active-button" : "disabled-button"
                }
                onClick={handleClick}
              >
                Request
              </button>
              {/* Show message only if needed */}
              {showMessage && (
                <h3 className="message">
                  This feature will be available once you reach 20,000 TopCoin.
                </h3>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default UserProfileWallet;